import appConfig from '@app';
import { store } from '@shared/store/store';
import {
  IAppUrls,
  IYouboraUrls,
  Url,
  ImagesUrls,
} from '@shared/types/interfaces/config';

class Config {
  // Misc
  environment: string;
  youboraCode: string;
  // Urls
  appUrls: IAppUrls;
  youboraUrls: IYouboraUrls;
  images: ImagesUrls;

  constructor() {
    // Misc
    this.environment = appConfig.environment;
    this.youboraCode = appConfig.youboraCode;

    // Urls
    this.appUrls = {
      apiUrl: 'https://api.tvup.cloud',
      baseImgUrl: 'https://media.tvup.cloud',
      cdnSyncUrl: 'https://mediasync.tvup.cloud',
      channelLicense: 'https://drmnew.tvup.cloud/license/',
      freeChannelLicense: 'https://drmnew.tvup.cloud/freelicense/',
      freeVodLicense: 'https://drmnew.tvup.cloud/freelicense/vod/',
      graphQLUrl: 'https://api.tvup.cloud/graphql',
      serverless: 'https://lpw3718wr0.execute-api.eu-west-1.amazonaws.com', // Prod: https://lpw3718wr0.execute-api.eu-west-1.amazonaws.com | Dev: https://6etq2m70e3.execute-api.eu-west-1.amazonaws.com
      vodLicense: 'https://drmnew.tvup.cloud/license/vod/',
    };
    this.youboraUrls = {
      dash: 'https://interceptor.npaw.com/plugin/video/dashjs/7.0.6-dashjs-js',
      hls: 'https://interceptor.npaw.com/plugin/video/hlsjs/7.0.3-hlsjs-js',
      shaka: 'https://interceptor.npaw.com/plugin/video/shaka/7.0.4-shaka-js',
    };
    this.images = {
      channelsClassic:
        'https://media.tvup.cloud/carriers/{OPERATOR_ID}/channels_epg_option.png',
      channelsDial:
        'https://media.tvup.cloud/carriers/{OPERATOR_ID}/dial_option.png',
    };
  }

  getUrl(url: Url) {
    const { app } = store.getState();

    return (
      app.urls[url || 'cdnSyncUrl'] || this.appUrls[url || 'cdnSyncUrl'] || ''
    );
  }
}

const AppConfig = new Config();
export default AppConfig;
